module.exports = __webpack_public_path__ + "static/media/zeus_docs.8126b700.wav";